import { render, staticRenderFns } from "./TravelFeature.vue?vue&type=template&id=3a93ecb8&scoped=true&"
import script from "./TravelFeature.vue?vue&type=script&lang=js&"
export * from "./TravelFeature.vue?vue&type=script&lang=js&"
import style0 from "./TravelFeature.vue?vue&type=style&index=0&id=3a93ecb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a93ecb8",
  null
  
)

export default component.exports